(function () {
	const FINCH_SECTION = ".main-product-finch";
	const FINCH_FILTER_ROOT = '[data-finch-color-media-filter="true"]';
	const KACHING_PRODUCT_LINK = "a.kaching-bundles__bundle-products__link";
	const kachingLinkObservers = new WeakMap();
	const FINCH_SWIPER_SELECTORS = [
		".js-media-list",
		".js-media-sublist",
		".js-media-list-mobile",
		".js-media-list-horizontal",
		".product__media--scroll",
		".global-variant-js-media-list",
	];
	const FINCH_GALLERY_SELECTORS = [
		":scope > .product__media-mobile",
		":scope > .product__media-list-wrapper-horizontal.global-variant-slider",
		":scope > .product__media-list-wrapper-horizontal.secondary",
		":scope > .product__media-wrapper",
	];

	function getFinchSection(root) {
		if (!root) {
			return null;
		}

		if (root.matches?.(FINCH_SECTION)) {
			return root;
		}

		return root.querySelector?.(FINCH_SECTION) || root.closest?.(FINCH_SECTION);
	}

	function disableKachingProductLinks(section) {
		section.querySelectorAll(KACHING_PRODUCT_LINK).forEach((link) => {
			link.removeAttribute("href");
			link.removeAttribute("target");
			link.removeAttribute("rel");
			if (link.getAttribute("tabindex") !== "-1") {
				link.setAttribute("tabindex", "-1");
			}
		});
	}

	function initKachingProductLinks(root) {
		const sections = root.matches?.(FINCH_SECTION)
			? [root]
			: root.querySelectorAll?.(FINCH_SECTION) || [];

		sections.forEach((section) => {
			if (kachingLinkObservers.has(section)) return;

			const preventProductLink = (event) => {
				if (!event.target.closest?.(KACHING_PRODUCT_LINK)) return;
				event.preventDefault();
				event.stopImmediatePropagation();
			};
			const observer = new MutationObserver(() => disableKachingProductLinks(section));

			section.addEventListener("click", preventProductLink, true);
			observer.observe(section, {
				childList: true,
				subtree: true,
				attributes: true,
				attributeFilter: ["href", "target", "rel", "tabindex"],
			});
			kachingLinkObservers.set(section, { observer, preventProductLink });
			disableKachingProductLinks(section);
		});
	}

	function destroyKachingProductLinks(root) {
		const sections = root.matches?.(FINCH_SECTION)
			? [root]
			: root.querySelectorAll?.(FINCH_SECTION) || [];

		sections.forEach((section) => {
			const state = kachingLinkObservers.get(section);
			if (!state) return;
			state.observer.disconnect();
			section.removeEventListener("click", state.preventProductLink, true);
			kachingLinkObservers.delete(section);
		});
	}

	function destroyFinchSwipers(scope) {
		if (!scope) {
			return;
		}

		FINCH_SWIPER_SELECTORS.forEach((selector) => {
			scope.querySelectorAll(selector).forEach((element) => {
				if (element.swiper) {
					element.swiper.destroy(true, true);
				}
			});
		});
	}

	function getColorFieldset(picker, finchRoot) {
		const optionPosition = finchRoot?.dataset.finchColorOptionPosition;
		if (!optionPosition) {
			return null;
		}

		return picker.querySelector(`[data-option-position="${optionPosition}"]`);
	}

	function refreshFinchZoomModal(sectionId, html) {
		const modalContentSource = html.querySelector(
			`#ProductModal-${sectionId} .product-media-modal__content`,
		);
		const modalContentDestination = document.querySelector(
			`#ProductModal-${sectionId} .product-media-modal__content`,
		);

		if (!modalContentSource || !modalContentDestination) {
			return;
		}

		modalContentDestination.innerHTML = modalContentSource.innerHTML;
	}

	function replaceFinchGallery(sectionId, html) {
		const section = document.getElementById(`shopify-section-${sectionId}`);
		const mediaSource = html.querySelector(
			`.product__outer[data-section="product-media-${sectionId}"]`,
		);
		const mediaDestination = section?.querySelector(
			`.product__outer[data-section="product-media-${sectionId}"]`,
		);
		if (!mediaSource || !mediaDestination) {
			return null;
		}

		FINCH_GALLERY_SELECTORS.forEach((selector) => {
			const source = mediaSource.querySelector(selector);
			const destination = mediaDestination.querySelector(selector);
			if (source && destination) {
				destroyFinchSwipers(destination);
				destination.replaceWith(source);
			}
		});

		return section;
	}

	async function refreshFinchMediaGallery(picker) {
		if (!picker.currentVariant) {
			return;
		}

		const sectionId = picker.dataset.originalSection || picker.dataset.section;
		const productUrl = picker.dataset.url;
		const requestUrl = `${productUrl}?variant=${picker.currentVariant.id}&section_id=${sectionId}`;
		picker.finchMediaAbortController?.abort();
		const controller = new AbortController();
		picker.finchMediaAbortController = controller;

		try {
			const response = await fetch(requestUrl, { signal: controller.signal });
			if (!response.ok) {
				throw new Error(`Failed to refresh Finch media: ${response.status}`);
			}
			const responseText = await response.text();
			if (controller.signal.aborted) return;
			const html = new DOMParser().parseFromString(responseText, "text/html");
			const section = replaceFinchGallery(sectionId, html);
			if (!section) return;
			refreshFinchZoomModal(sectionId, html);
			if (section && typeof window.initProductPage === "function") {
				window.initProductPage(section);
			}

			if (typeof window.syncKbiteForFinch === "function") {
				window.syncKbiteForFinch(section);
			}
		} catch (error) {
			if (error.name !== "AbortError") console.error(error);
		}
	}

	function patchFinchVariantPicker(picker) {
		if (picker.dataset.finchPickerPatched === "true") {
			return;
		}

		const finchRoot = picker.closest(FINCH_FILTER_ROOT);
		const colorFieldset = getColorFieldset(picker, finchRoot);
		if (!finchRoot || !colorFieldset) {
			return;
		}

		picker.dataset.finchPickerPatched = "true";
		picker.dataset.variantMediaDisplay = "show_all";
		picker.updateMedia = () => {};

		colorFieldset.addEventListener("change", () => {
			picker.updateOptions();
			picker.updateMasterId();

			if (picker.currentVariant) {
				refreshFinchMediaGallery(picker);
			}
		});
	}

	function patchFinchVariantPickers(root) {
		const scope = root || document;
		scope
			.querySelectorAll(
				`${FINCH_FILTER_ROOT} variant-radios, ${FINCH_FILTER_ROOT} variant-selects`,
			)
			.forEach(patchFinchVariantPicker);
	}

	function mobileSliderInit(isUpdate) {
		const scope = document;
		const mobileSliders = scope.querySelectorAll(
			`${FINCH_SECTION} .js-media-list-mobile`,
		);

		mobileSliders.forEach((sliderElement) => {
			if (isUpdate && sliderElement.swiper) {
				sliderElement.swiper.destroy(true, true);
			}

			if (sliderElement.swiper) {
				return;
			}

			const parent = sliderElement.closest(".product__media-mobile");
			const nextEl = parent?.querySelector(".swiper-btn--next");
			const prevEl = parent?.querySelector(".swiper-btn--prev");

			new Swiper(sliderElement, {
				slidesPerView: "auto",
				autoHeight: true,
				spaceBetween: 8,
				navigation: {
					nextEl,
					prevEl,
				},
				on: {
					slideChange: function () {
						window.pauseAllMedia?.();
					},
				},
			});
		});
	}

	function finchSwiperInit(scope) {
		const finchSection = getFinchSection(scope || document);

		if (!finchSection) {
			return;
		}

		destroyFinchSwipers(finchSection);

		if (typeof subSliderInit === "function") {
			subSliderInit(true);
		}
		if (typeof sliderInit === "function") {
			sliderInit(true);
		}
		mobileSliderInit(true);
		if (typeof scrollSliderInit === "function") {
			scrollSliderInit(true);
		}
		if (typeof sliderHorizontalInit === "function") {
			sliderHorizontalInit(true);
		}
	}

	function initFinchSection(root) {
		const finchSection = getFinchSection(root || document);

		if (!finchSection && root !== document) {
			return;
		}

		patchFinchVariantPickers(root || document);
		initKachingProductLinks(root || document);
		mobileSliderInit(false);
	}

	window.initProductPage = function (sectionEl) {
		const finchSection = getFinchSection(sectionEl);

		if (!finchSection) {
			return;
		}

		patchFinchVariantPickers(finchSection);
		finchSwiperInit(finchSection);
	};

	document.addEventListener("DOMContentLoaded", function () {
		initFinchSection(document);
	});

	document.addEventListener("shopify:section:load", function (event) {
		initFinchSection(event.target);
	});

	document.addEventListener("shopify:section:unload", function (event) {
		destroyKachingProductLinks(event.target);
		event.target
			.querySelectorAll(
				`${FINCH_FILTER_ROOT} variant-radios, ${FINCH_FILTER_ROOT} variant-selects`,
			)
			.forEach((picker) => picker.finchMediaAbortController?.abort());
	});
})();
